module.exports = __webpack_public_path__ + "img/crystal_rift.8ca5fa93.png";